import getScrollbarWidth from './get-scrollbar-width';

let wScroll = 0;

export default function (action) {
  const body = document.querySelector('body');
  const siteWrapper = document.querySelector('#site-wrapper');
  const toggleAction = action;

  if (toggleAction === 'disable') {
    wScroll = window.scrollY;
    const cHeight = siteWrapper.offsetHeight;
    body.style.height = `${cHeight}px`;
    body.style.top = `-${wScroll}px`;
    body.style.paddingRight = `${getScrollbarWidth()}px`;
    body.classList.add('disable-scroll');
    
  } else {
    body.style.height = null;
    body.style.top = null;
    body.classList.remove('disable-scroll');
    body.style.removeProperty('padding-right');
    window.scroll(0,wScroll);
  }
}
